import { createAction } from '@reduxjs/toolkit';
import type { AuthUserInfo } from './types';

/** An action that is dispatched when the user logs out. */
const logOut = createAction('AUTH.LOGOUT');
/** An action that is dispatched when the auth token issued date changes. */
const updateTokenIssuedAt = createAction<{ issuedAt: number }>('AUTH.UPDATE_ISS');
/** An action that is dispatched when the app begins fetching the user info. */
const fetchUserStart = createAction('AUTH.FETCH_USER.START');
/** An action that is dispatched when the app completes fetching the user info successfully. */
const fetchUserSuccess = createAction<{ user: AuthUserInfo }>('AUTH.FETCH_USER.SUCCESS');
/** An action that is dispatched when the app completes fetching the user info unsuccessfully. */
const fetchUserFailure = createAction('AUTH.FETCH_USER.FAILURE');
/** An action that is dispatched when the terms of service acceptance date is updated successfully. */
const updateTosAcceptedAtSuccess = createAction<{ tosAcceptedAt: string }>('AUTH.UPDATE_TOS_ACCEPTANCE_DATE.SUCCESS');

export const authActions = {
  logOut,
  fetchUserStart,
  fetchUserFailure,
  fetchUserSuccess,
  updateTokenIssuedAt,
  updateTosAcceptedAtSuccess,
};
